import { createActionName } from "../../../utility"

export const reducerName = "workspaces"

export const WORKSPACES = createActionName(reducerName, "WORKSPACES")
export const WORKSPACE = createActionName(reducerName, "WORKSPACE")
